import { DatePicker, Form, FormInstance, Radio } from 'antd';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import locale from 'antd/es/date-picker/locale/zh_TW';
import { LocationCheckGroupContainer } from '../shared/location-check-group/location-check-group.container';

type ExportPosDataComponentProps = {
  form: FormInstance;
};

export function ExportPosDataComponent(props: ExportPosDataComponentProps) {
  useEffect(() => {
    props.form.resetFields();
  }, [props.form]);

  return (
    <Form
      form={props.form}
      initialValues={{
        date: dayjs().startOf('day'),
        layoutType: 'SEPARATED',
      }}
    >
      <Form.Item>
        <div>請選擇要匯出的取貨日期。</div>
        <div className="text-red-400">
          匯出可能需要 1 到 2 分鐘，請不要關閉瀏覽器。
        </div>
      </Form.Item>
      <Form.Item
        label="日期"
        name="date"
        rules={[{ required: true, message: '請選擇日期' }]}
      >
        <DatePicker locale={locale} />
      </Form.Item>
      <Form.Item
        label="匯出類型"
        name="layoutType"
        rules={[{ required: true, message: '請選擇匯出類型' }]}
      >
        <Radio.Group
          options={[
            { label: 'POS', value: 'SEPARATED' },
            { label: 'A4', value: 'COMBINED' },
          ]}
        />
      </Form.Item>
      <LocationCheckGroupContainer />
    </Form>
  );
}
